export const APP_TOGGLE_NAV_DRAWER = 'APP_TOGGLE_NAV_DRAWER';

export function appToggleNavDrawer(data) {
  return {
    type: APP_TOGGLE_NAV_DRAWER,
    data,
  };
}
